import "./ContentBlock.css"

export default function ContentBlock({children}) {
    return (
        <div className={"content-block"}>{children}</div>
    )
}